import React, { useMemo } from 'react';

import ToolbarRichSelect from './ToolbarRichSelect';
import { ORDER_CHANNELS, STORE_ORDER_CHANNELS } from './menuChannels';
import { filterOrderChannelsByServices } from './restaurantServiceAccess';

const OPTION_META = {
  offline: {
    color: '#1d4ed8',
    bg: '#dbeafe',
    hint: 'In-restaurant dine-in orders',
  },
  myeats: {
    color: '#0369a1',
    bg: '#e0f2fe',
    hint: 'My Eats delivery and pickup',
  },
  jreats: {
    color: '#7c3aed',
    bg: '#ede9fe',
    hint: 'Junior Eats school orders',
  },
  catering: {
    color: '#0f766e',
    bg: '#ccfbf1',
    hint: 'Catering orders and quotes',
  },
  partyHall: {
    color: '#a16207',
    bg: '#fef3c7',
    hint: 'Party hall quotes and bookings',
  },
  pos: {
    color: '#1d4ed8',
    bg: '#dbeafe',
    hint: 'In-store POS orders',
  },
  restaurant: {
    color: '#b45309',
    bg: '#ffedd5',
    hint: 'Company restaurant orders',
  },
};

function toRichOptions(channels) {
  return channels.map((channel) => {
    const meta = OPTION_META[channel.key] || {
      color: '#475569',
      bg: '#e2e8f0',
      hint: `${channel.label} orders`,
    };
    return {
      value: channel.key,
      label: channel.label,
      hint: meta.hint,
      Icon: channel.icon,
      color: meta.color,
      bg: meta.bg,
    };
  });
}

/**
 * Opted-in order service selector for the Orders search toolbar.
 * Replaces the Orders left-nav sub-items (Dine-In / My Eats / …).
 */
const OrdersServiceChannelSelect = ({
  value,
  onChange,
  enabledServiceTypes = null,
  servicesLoading = false,
  isStore = false,
}) => {
  const options = useMemo(() => {
    if (isStore) {
      return toRichOptions(STORE_ORDER_CHANNELS);
    }
    if (servicesLoading) {
      return toRichOptions(ORDER_CHANNELS);
    }
    const channels = filterOrderChannelsByServices(ORDER_CHANNELS, enabledServiceTypes, {
      servicesLoading: false,
      allowAllWhenUnknown: true,
    });
    return toRichOptions(channels.length ? channels : ORDER_CHANNELS);
  }, [enabledServiceTypes, servicesLoading, isStore]);

  if (!options.length) return null;

  return (
    <ToolbarRichSelect
      panelId="orders-service-channel"
      value={value}
      onChange={onChange}
      options={options}
      ariaLabel="Order service"
      panelTitle="Service"
    />
  );
};

export default OrdersServiceChannelSelect;
